import React from 'react';
import Navbar from '../components/navbar';
import DetallesDepto from '../components2/detallesDeptoCapis';

function DetallesDepartamento() {
    return (
        <DetallesDepto />
    )
}

export default DetallesDepartamento;